import React from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { Tiles } from '@Components/Tiles'
import { TilesCardLook } from '@Components/Tiles/Card/Look'
import { useTileSettings } from '@Components/Tiles/settings'
import { LookTile, Maybe, PagePresentation, PageType, Scalars } from '@Generated/graphql'
import { getPins } from '@Globals/CMS/LookHelpers'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { Image } from '@Globals/Image'

import styles from './Looks.module.scss'

export const Looks = ({
  id,
  looks,
  settings,
  title,
}: {
  id?: string
  looks: LookTile[]
  settings?: Maybe<Scalars['JSON']>
  title?: string
}) => {
  const tileSettings = useTileSettings(settings)
  const openModal = useCMSModalOpen()

  if (!looks || looks.length === 0) {
    return null
  }

  return (
    <BlockContainer
      appearance={{}}
      className={styles.blockContainer}
      common={{
        title,
        titleElement: 'h2',
        position: looks.length === 1 ? 'left' : 'top',
      }}
      commonWidth={looks.length === 1 ? 'half' : undefined}
      id={id}
      noPadding
      presentation={PagePresentation.Full}
    >
      <Tiles settings={tileSettings}>
        {looks.map(look => (
          <TilesCardLook
            key={look.id}
            ambassadorHandle={look.ambassadorHandle || undefined}
            cardAspectRatio={tileSettings.cardAspectRatio}
            cardSize={tileSettings.cardSize}
            cardVariant={tileSettings.cardVariant}
            image={look.asset as Image}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()

              openModal(PageType.Look, look.id!, 'inherit', PagePresentation.Sidebar)
            }}
            pins={getPins(look, undefined, PagePresentation.Sidebar)}
            presentation={PagePresentation.Sidebar}
            sizes={tileSettings.width ? `${tileSettings.width}px` : undefined}
          />
        ))}
      </Tiles>
    </BlockContainer>
  )
}
